import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import { OperatorCompaniesResponseDto } from './dtos/operator-companies.dto';
import { OperatorCompaniesMapper } from './mappers/operator-companies.mapper';
import { OperatorCompany } from '../state/operator-companies/operator-companies-state.model';

@Injectable({ providedIn: 'root' })
export class OperatorCompaniesApi {
  private readonly _http = inject(HttpClient);
  private readonly _env = inject(ENV_CONFIG);
  private readonly _baseUrl = this._env.pureSpectrum.url;
  private readonly _mapper = new OperatorCompaniesMapper();

  public getCompanies(): Observable<OperatorCompany[]> {
    return this._http
      .get<OperatorCompaniesResponseDto>(`${this._baseUrl}/companies`)
      .pipe(map((res) => this._mapper.fromDtoList(res.companies)));
  }
}
